//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "payment-list",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'付款清单',
        url:'api/payment/page',
        property: "createdDate",
        inputCondition:{
          placeholder:'单号/供应商/公司',
          searchCondition:'key',
          rules:[{field:"supplier.supplierName-supplier.supplierCode-company.companyName-company.companyCode-code", option: "LIKE_ANYWHERE"}]
        }
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    viewDetail(item){
      this.$router.push(`/payment-detail/${item.id}`);
    },
  },
  mounted(){
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/payment-list.vue